define.alias("shared/components/shared/ui/switcher/item", "media/components/shared/ui/switcher/item");